import { CarrierLogo } from '@/components/carrier-logo';
import { Link } from '@/components/link';
import { CarrierPageInterface } from '@/types';
import { getPreferredIdentifier, getUrlDomain } from '@/utils/helpers';
import { tv } from '@/utils/styles';

interface Props {
  readonly carrier: CarrierPageInterface;
}

const CarrierSummary = ({ carrier }: Props) => {
  const carrierIdentifier = getPreferredIdentifier(carrier.identifiers);

  const { base, logo, dl, dt, dd } = styles();

  return (
    <div className={base()}>
      <span className={logo()}>
        {carrierIdentifier?.value ? (
          <CarrierLogo carrierCode={carrierIdentifier.value} mode={carrier.mode} size="lg" />
        ) : null}
      </span>
      {carrier.carrierWebsite && (
        <dl className={dl()}>
          <dt className={dt()}>Website </dt>
          <dd className={dd()}>
            <Link href={carrier.carrierWebsite} target="_blank" rel="nofollow noopener">
              {getUrlDomain(carrier.carrierWebsite)}
            </Link>
          </dd>
        </dl>
      )}
      {carrier.country?.name && (
        <dl className={dl()}>
          <dt className={dt()}>Headquarters </dt>
          <dd className={dd()}>{carrier.country.name}</dd>
        </dl>
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-center',
    logo: 'mr-6 grid size-8 place-items-center rounded-full bg-white',
    dl: 'm-0 mr-8',
    dt: 'm-0 text-sm font-semibold uppercase leading-snug',
    dd: 'm-0 text-base',
  },
});

export { CarrierSummary };
